module.exports = __webpack_public_path__ + "media/images/google_logo-39c52b1bcccb20569aa4ea620fdc6b69.png";